import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import Select from 'react-select'
import CsvDownloader from 'react-csv-downloader';

import { faFileDownload, faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { request, reportErrorToHoneybadger } from '../../helpers/Requests'

import Page from '../../components/shared/Page';
import TypeOfPersonSelect from '../../components/shared/TypeOfPersonSelect';
import { formatDate, convertToSlug, arrayParamBuilder, STAFF_TYPE_OF_PEOPLE } from '../../utilities/Generic.js'

class SicknessReportIndex extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleMultiSelectChange = this.handleMultiSelectChange.bind(this);
  }

  state = {
    locations: [],
    roles: [],
    tags: [],
    people: [],

    date_from: formatDate(new Date(), 365),
    date_to: formatDate(new Date(), 0),
    location_id: this.props.match.params.id,
    role_id: "",
    type_of_person: "",
    tag_ids: [],

    locationsLoaded: false,
    rolesLoaded: false,
    tagsLoaded: false,
    sicknessesLoaded: false,

    error: null,
    unauthorized: null
  }

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({
      [name]: value,
      sicknessesLoaded: false
    }, () => {
      // A setState callback?! Ensuring all states are set before triggering the next line?!
      this.fetchData()
    });
  }

  handleMultiSelectChange(data) {
    const fakeEvent = {}
    fakeEvent.target = {}
    fakeEvent.target.name = "tag_ids"
    fakeEvent.target.value = data.map(option => option.value);

    this.handleChange(fakeEvent)
  }

  fetchData() {
    let params = `date_from=${this.state.date_from}&date_to=${this.state.date_to}&location_id=${this.state.location_id}&role_id=${this.state.role_id}&type_of_person=${this.state.type_of_person}${arrayParamBuilder(null, "tag_ids", this.state.tag_ids)}`

    request('GET', `/v1/a/staff_sicknesses/by_person?${params}`, null, () => this.setState({ unauthorized: true }))
      .then(data => {
        this.setState({ people: data, sicknessesLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, sicknessesLoaded: true })
      })
  }

  render() {
    const { people, locationsLoaded, rolesLoaded, tagsLoaded, sicknessesLoaded, error, unauthorized } = this.state;

    if (localStorage.license === "entry") {
      return <Redirect to="/upgrade" />
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (locationsLoaded === false || rolesLoaded === false || tagsLoaded === false) {
      return <p>Loading ...</p>;
    }

    if (locationsLoaded && rolesLoaded && tagsLoaded) {
      return (
        <div>
          <Page title="Staff Sickness">
            {this.renderFilters()}

            {sicknessesLoaded ? (
              <div className="widgets">
                {people.map((person, index) => (
                  this.renderPersonSection(person, index)
                ))}

                {people.length === 0 && (
                  <p>No data found for those filters.</p>
                )}
              </div>
            ) : (
              <p>Loading ...</p>
            )}
          </Page>
        </div>
      );
    }
  }

  renderDownloadCSV(person, sicknesses) {
    let filename = `${convertToSlug(person.name)}-sicknesses-${this.state.date_from}-to-${this.state.date_to}.csv`

    let running_total = 0;
    sicknesses = sicknesses.map(sickness => {
      running_total += sickness.duration

      return {
        ...sickness,
        running_total
      }
    });

    let columns = [
      { displayname: "Start Time", id: "start_time" },
      { displayname: "End Time", id: "end_time" },
      { displayname: "Duration (days)", id: "duration" },
      { displayname: "Reason", id: "reason" },
      { displayname: "Doctor's Note Provided?", id: "doctor_note_provided" },
      { displayname: "Running Total (days)", id: "running_total" }
    ];

    return (
      <CsvDownloader datas={sicknesses} columns={columns} filename={filename} className="edit-button download-csv relative-csv right sickness" wrapColumnChar='"'>
        <div>
          <FontAwesomeIcon icon={faFileDownload} />
          <h4>Download CSV</h4>
        </div>
      </CsvDownloader>
    )
  }

  renderPersonSection(person, index) {
    const totalDays = person.sicknesses.reduce((total, sickness) => total + sickness.duration, 0);

    return (
      <React.Fragment key={index}>
        <h3 className="no-bottom-margin top-padding">{person.name}</h3>
        <div className="small-top-padding">Total days: {totalDays}</div>

        {person.sicknesses.length > 0 &&
          <>
            {this.renderDownloadCSV(person, person.sicknesses)}
            <table className="table big-table worked-hours-table bottom-margin" data-testid="table">
              <thead>
                <tr className="tr heading">
                  <th className="th">Start Time</th>
                  <th className="th">End Time</th>
                  <th className="th">Duration (days)</th>
                  <th className="th">Reason</th>
                  <th className="th">Doctor's Note Provided?</th>
                </tr>
              </thead>
              <tbody>
                {person.sicknesses.map((sickness, index) => (
                  this.renderPersonSicknesses(sickness, index)
                ))}
              </tbody>
            </table>
          </>
        }
      </React.Fragment>
    )
  }

  renderPersonSicknesses(sickness, index) {
    return (
      <tr className="tr" key={index}>
        <td className="td">{sickness.start_time}</td>
        <td className="td">{sickness.end_time}</td>
        <td className="td">{sickness.duration}</td>
        <td className="td">{sickness.reason}</td>
        <td className="td center">{sickness.doctor_note_provided ? <FontAwesomeIcon icon={faCheckCircle} /> : <FontAwesomeIcon icon={faTimes} />}</td>
      </tr>
    )
  }

  timeFrom(timeString) {
    return new Date(`1970/01/01 ${timeString.slice(0, -2)}`)
  }

  renderFilters() {
    const { date_from, date_to, location_id, type_of_person, role_id, tag_ids, locations, roles, tags } = this.state;

    const selectOptions = tags.map(tag => ({ value: tag.id, label: tag.name }))
    const selectedTags = selectOptions.filter(option => tag_ids.includes(option.value))

    return (
      <div className="export-selection">
        <div className="selection-block">
          <label className="column">Date from:</label>
          <input className="column" type="date" name="date_from" value={date_from} onChange={this.handleChange} />
        </div>

        <div className="selection-block">
          <label className="column">Date to:</label>
          <input className="column" type="date" name="date_to" value={date_to} onChange={this.handleChange} />
        </div>

        <div className="selection-block">
          <label className="column">Location:</label>
          <select name="location_id" value={location_id} onChange={this.handleChange}>
            {locations.map((location) => (
              <option value={location.id} key={location.id}>{location.name}</option>
            ))}
          </select>
        </div>

        <div className="selection-block">
          <label className="column">Type:</label>
          <TypeOfPersonSelect defaultText="All" value={type_of_person} onChange={this.handleChange} options={STAFF_TYPE_OF_PEOPLE} />
        </div>

        <div className="selection-block">
          <label className="column">Roles:</label>
          <select name="role_id" value={role_id} onChange={this.handleChange}>
            <option value="">All</option>
            {roles.map((role) => (
              <option value={role.id} key={role.id}>{role.name}</option>
            ))}
          </select>
        </div>

        <div className="selection-block">
          <label className="column">Filter by Tags:</label>
          <Select onChange={this.handleMultiSelectChange} options={selectOptions} value={selectedTags} isMulti={true} unstyled={true} className="react-select" classNamePrefix="react-select" placeholder={"All"} />
        </div>
      </div>
    )
  }

  componentDidMount() {
    // Filter data

    request('GET', `/v1/a/locations`, null, () => this.setState({ unauthorized: true }))
      .then(data => {
        const filteredLocations = data.filter(location => location.staff_fulfilment)

        localStorage.setItem("staff_fulfilment_access", filteredLocations.length > 0)

        this.setState({ locations: filteredLocations, locationsLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, locationsLoaded: true })
      })

    request('GET', `/v1/a/roles/names_and_ids`, null, () => this.setState({ unauthorized: true }))
      .then(data => {
        this.setState({ roles: data, rolesLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, rolesLoaded: true })
      })

    request('GET', `/v1/a/tags/names_and_ids`, null, () => this.setState({ unauthorized: true }))
      .then(data => {
        this.setState({ tags: data, tagsLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, tagsLoaded: true })
      })

    // Form data

    this.fetchData()
  }
}

export default SicknessReportIndex;
